exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  display: inline-block;\n}\n.loader > .spinner {\n  animation: rotate 0.8s infinite linear;\n  border-style: solid;\n  border-right-color: transparent !important;\n  border-radius: 50%;\n}\n@keyframes rotate {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
